import { BaseHolding } from './base-holding';


/**
 *	To be used for blending constructs as a reference to child portfolios.
 *  All necessary attributes are already in BaseHolding - description of what they mean in the context of PortfolioReference here:
 * @identifier id of PortfolioReference
 * @description name of portfolio
 * @weight weight of the child in relation to the parent
 * @value amount
 * @subType type of Portfolio
 * @baseModel baseModel - applicable if portfolio is customised from a model
 * @flags Object containing flags that is useful for determining characteristics of the portfolio
 */
export class PortfolioReference extends BaseHolding {

	public baseModel?: string;
	public flags?: any;

	constructor() {
		super();
	}
}
